export default {
  startGame: 'startGame',
  saveProgress: 'saveProgress',
  nextInstruction: 'nextInstruction',
  finishGame: 'finishGame',
}
